import { useContext } from "react";
import { AccessContext } from "./AccessProvider";
import type { AccessContextValue } from "./types";

export function useAccess(): AccessContextValue {
    const context = useContext(AccessContext);
    if (context === undefined) {
        throw new Error("useAccess must be used within an AccessProvider");
    }
    return context;
}
